var React = require('react');

function IconTooltip (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1.25","y":"1.25","width":"18.5","height":"18.5","rx":"9.25","stroke":"#001D3B","strokeWidth":"1.5","key":0}),React.createElement("path",{"d":"M8.914 14.39C8.914 15.076 9.446 15.58 10.132 15.58C10.818 15.58 11.364 15.076 11.364 14.39C11.364 13.704 10.818 13.186 10.132 13.186C9.446 13.186 8.914 13.704 8.914 14.39ZM9.264 8.034C9.306 7.628 9.656 7.18 10.272 7.18C10.874 7.18 11.28 7.53 11.28 8.048C11.28 9.154 9.04 9.476 9.04 11.282C9.04 12.066 9.53 12.626 9.684 12.808L11.098 11.828C10.972 11.702 10.86 11.562 10.86 11.324C10.86 10.484 13.1 10.078 13.1 8.02C13.1 6.578 11.854 5.5 10.272 5.5C8.746 5.5 7.752 6.466 7.5 7.572L9.264 8.034Z","fill":"#001D3B","key":1})]);
}

IconTooltip.defaultProps = {"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none"};

module.exports = IconTooltip;

IconTooltip.default = IconTooltip;
